import { render, staticRenderFns } from "./ShapeDataSet.vue?vue&type=template&id=38ccdaae"
import script from "./ShapeDataSet.vue?vue&type=script&lang=ts"
export * from "./ShapeDataSet.vue?vue&type=script&lang=ts"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./ShapeDataSet.vue?vue&type=style&index=1&id=38ccdaae&prod&lang=css"
import style2 from "../../scss/base.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports